"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntryPickerLarge = void 0;
var React = require("react");
var Spinner_1 = require("../../Animations/Spinner");
var Grid_1 = require("../../Grids/Grids/Grid");
var Renderers_1 = require("../../Grids/Renderers");
var Localization_1 = require("../../Localization");
var EntryPicker_styles_1 = require("./EntryPicker.styles");
exports.EntryPickerLarge = React.forwardRef(function (_a, ref) {
    var Data = _a.Data, ID1HeaderText = _a.ID1HeaderText, ID2HeaderText = _a.ID2HeaderText, ID3HeaderText = _a.ID3HeaderText, SaveGridLayoutID = _a.SaveGridLayoutID, IsLoading = _a.IsLoading, OnSelectedItemChanged = _a.OnSelectedItemChanged;
    var _b = React.useState({}), _c = _b[0], EntryGridApi = _c.EntryGridApi, GridColumnApi = _c.GridColumnApi, SetGridState = _b[1];
    var headers = [
        {
            cellRendererFramework: Renderers_1.ResidentCell,
            field: "firstName",
            headerName: Localization_1.strings.EntryPicker_Label_FirstName,
            width: 135,
        },
        { headerName: Localization_1.strings.EntryPicker_Label_PreferredName, field: "prefName", width: 180 },
        { headerName: Localization_1.strings.EntryPicker_Label_LastName, field: "lastName", width: 135 },
        { headerName: ID1HeaderText, field: "id1", width: 80 },
        { headerName: ID2HeaderText, field: "id2", width: 80 },
        { headerName: ID3HeaderText, field: "id3", width: 80 },
        { headerName: Localization_1.strings.EntryPicker_Label_RoomSpace, field: "roomSpace", width: 200 },
        {
            cellRendererFramework: Renderers_1.EntryStatusCell,
            field: "status",
            headerName: Localization_1.strings.EntryPicker_Label_Status,
            width: 135,
        },
        { headerName: Localization_1.strings.EntryPicker_Label_Category, field: "category", width: 135 },
        { headerName: Localization_1.strings.EntryPicker_Label_EntryID, field: "entryId", width: 135 },
    ];
    var buildData = function () {
        var rows = [];
        Data.forEach(function (e) {
            rows.push({
                category: e.Category,
                dob: e.DateOfBirth,
                entryId: e.EntryID,
                firstName: {
                    image: {
                        AltText: e.AvatarInfo.AltText,
                        Initials: e.AvatarInfo.Initials,
                        OccupantSpecies: e.AvatarInfo.OccupantSpecies,
                        Src: e.AvatarInfo.Src,
                    },
                    name: e.FirstName,
                },
                id1: e.ID1,
                id2: e.ID2,
                id3: e.ID3,
                lastName: e.LastName,
                prefName: e.PreferredName,
                roomSpace: e.RoomSpace,
                status: e.Status,
            });
        });
        return rows;
    };
    // The component instance will be extended with whatever you return from the callback passed as the second argument
    React.useImperativeHandle(ref, function () { return ({
        handleDownKeyPressed: function () {
            moveFocusToFirstRow();
        },
    }); });
    var moveFocusToFirstRow = function () {
        // scrolls to the first row
        EntryGridApi.ensureIndexVisible(0);
        // scrolls to the first column
        var firstCol = GridColumnApi.getAllDisplayedColumns()[0];
        EntryGridApi.ensureColumnVisible(firstCol);
        // Sets focus on first row first column cell
        EntryGridApi.setFocusedCell(0, firstCol);
    };
    var handleSelectionChanged = function (event) {
        var row = event.api.getSelectedNodes()[0].data;
        handleEntrySelectionChanged(row);
    };
    var handleEntrySelectionChanged = function (row) {
        var entry = {
            AvatarInfo: row.firstName.image,
            Category: row.category,
            DateOfBirth: row.dob,
            EntryID: row.entryId,
            FirstName: row.firstName.name,
            ID1: row.id1,
            ID2: row.id2,
            ID3: row.id3,
            LastName: row.lastName,
            PreferredName: row.prefName,
            RoomSpace: row.roomSpace,
            Status: row.status,
        };
        OnSelectedItemChanged(entry);
    };
    var handleCellKeyPress = function (e) {
        if (e.event.key === "Enter") {
            var entry = e.node.data;
            handleEntrySelectionChanged(entry);
        }
    };
    var onGridReady = function (params) {
        SetGridState({ EntryGridApi: params.api, GridColumnApi: params.columnApi });
    };
    return (React.createElement("div", { style: { height: "100%" }, tabIndex: 0 }, IsLoading ?
        React.createElement(EntryPicker_styles_1.CenteredWrapper, null,
            React.createElement(Spinner_1.Spinner, null))
        :
            React.createElement(Grid_1.Grid, { defaultColDef: { resizable: true, filter: true, sortable: true }, columnDefs: headers, rowData: buildData(), suppressDragLeaveHidesColumns: true, SaveLayout: true, SaveLayoutID: SaveGridLayoutID, rowSelection: "single", localeText: { noRowsToShow: Localization_1.strings.EntryPicker_Message_NoResults }, onCellKeyPress: handleCellKeyPress, onSelectionChanged: handleSelectionChanged, onGridReady: onGridReady })));
});
